<template>
  <div class="passwordReset__form">
    <form @submit.prevent="$emit('password-reset', resetData)" class="form">
      <img src="@/assets/logo.png" width="180" alt="Invision Logo" />
      <p class="passwordReset__title">Reset your password</p>
      <p class="disclaimer warning" v-if="!isOTPValid">
        We have sent you <span class="underline">another</span> email. This email contains a One Time Password (OTP).
      </p>
      <p class="disclaimer" v-if="!isOTPValid">
        Please enter your OTP:
      </p>
      <p class="disclaimer" v-if="isOTPValid" :style="hideInputs">
        Please enter your new password in the inputs below.
      </p>
      <p class="submitMessage" v-if="submitMessage">{{ submitMessage }}</p>
      <p class="error" v-if="error">{{ error }}</p>
      <div class="field" v-if="!isOTPValid">
        <v-otp-input
          ref="otpInput"
          input-classes="otp-input"
          separator="-"
          :num-inputs="6"
          :is-input-num="true"
          @on-complete="otpEntryComplete"
        />
      </div>
      <div class="field" v-if="isOTPValid" :style="hideInputs">
        <span class="icon input-icon">
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 22H3C1.3 22 0 20.7 0 19V12C0 10.3 1.3 9 3 9H17C18.7 9 20 10.3 20 12V19C20 20.7 18.7 22 17 22ZM3 11C2.4 11 2 11.4 2 12V19C2 19.6 2.4 20 3 20H17C17.6 20 18 19.6 18 19V12C18 11.4 17.6 11 17 11H3Z"
            />
            <path
              d="M5 11C4.4 11 4 10.6 4 10V6C4 4.4 4.6 2.9 5.8 1.8C6.9 0.6 8.4 0 10 0C12.8 0 15.3 2 15.9 4.8C16 5.3 15.6 5.9 15.1 6C14.6 6.1 14 5.8 13.9 5.2C13.5 3.3 11.9 2 10 2C8.9 2 7.9 2.4 7.2 3.2C6.4 3.9 6 4.9 6 6V10C6 10.6 5.6 11 5 11Z"
            />
          </svg>
        </span>
        <input
          type="password"
          class="input has-icon"
          name="password"
          autocomplete="new-password"
          placeholder="New password"
          v-model="resetData.passwordOne"
          @input="$emit('clear-error')"
        />
      </div>
      <div class="field" v-if="isOTPValid" :style="hideInputs">
        <span class="icon input-icon">
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 22H3C1.3 22 0 20.7 0 19V12C0 10.3 1.3 9 3 9H17C18.7 9 20 10.3 20 12V19C20 20.7 18.7 22 17 22ZM3 11C2.4 11 2 11.4 2 12V19C2 19.6 2.4 20 3 20H17C17.6 20 18 19.6 18 19V12C18 11.4 17.6 11 17 11H3Z"
            />
            <path
              d="M5 11C4.4 11 4 10.6 4 10V6C4 4.4 4.6 2.9 5.8 1.8C6.9 0.6 8.4 0 10 0C12.8 0 15.3 2 15.9 4.8C16 5.3 15.6 5.9 15.1 6C14.6 6.1 14 5.8 13.9 5.2C13.5 3.3 11.9 2 10 2C8.9 2 7.9 2.4 7.2 3.2C6.4 3.9 6 4.9 6 6V10C6 10.6 5.6 11 5 11Z"
            />
          </svg>
        </span>
        <input
          type="password"
          class="input has-icon"
          autocomplete="password"
          placeholder="Confirm new password"
          v-model="resetData.passwordTwo"
          @input="$emit('clear-error')"
        />
      </div>
      <p class="disclaimer" v-if="isOTPValid" :style="hideInputs">
        Password must contain at least 1 uppercase, lowercase, numerical and symbol characters each.
      </p>
      <div class="button-container">
        <button
          class="passwordReset__button"
          v-if="isOTPValid"
          :disabled='!resetData.passwordTwo'
          :style="hideInputs"
        >
          Reset Password
        </button>
        <p class="disclaimer forgot-link">
          <router-link to="/login">
            Return to Login
          </router-link>
        </p>
      </div>
      <hr />
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'PasswordResetForm',
  props: ['error', 'submitMessage'],
  data() {
    return {
      resetData: {
        passwordOne: '',
        passwordTwo: '',
        email: '',
        otp: ''
      },
      submitted: false
    }
  },
  computed: {
    ...mapGetters({ isOTPValid: 'user/validOTP' }),
    hideInputs() {
      if (this.submitMessage !== null && this.error === null) {
        return {
          display: 'none'
        }
      }
      return ''
    }
  },
  methods: {
    ...mapActions({ validateOTP: 'user/validateOTP' }),
    async otpEntryComplete() {
      this.resetData.otp = this.$refs.otpInput.otp.join('')
      const otp = this.$refs.otpInput.otp.join('')
      await this.validateOTP({ otp })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/components.scss";
@import "@/style/passwordReset.scss";

.disclaimer {
  text-align: center;
  font-size: 0.8rem;
}

.error {
  color: red;
  text-align: center;
}

.submitMessage {
  color: black;
  text-align: center;
}

.forgot-link {
  text-align: right;
}

.button-container {
  width: 100%;
}

::v-deep .otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
  }
  ::v-deep .otp-input::-webkit-inner-spin-button,
  ::v-deep .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .submitted {
  background: linear-gradient(60deg, #00b3bb 0%, #34319e 100%) !important;
}

.warning {
  font-size: 16px;
}

.underline {
  text-decoration: underline;
}
</style>
